import React from 'react';
import './ContainerBox.scss';

const ContainerBox = props => {
    return (
        <div className={`container-box ${props.className}`} style={props.style}>
            {props.children}
        </div>
    )
}

export default ContainerBox;